import { useEffect, useState } from "react";

const EVENT_HOUR = 23;
const UNITS = [["g", 86400000], ["h", 3600000], ["m", 60000], ["s", 1000]];

function remaining(iso) {
  const start = new Date(`${iso}T${String(EVENT_HOUR).padStart(2, "0")}:00:00`);
  return start.getTime() - Date.now();
}

/* Live countdown to the event night (starts 23:00 local time). */
export const Countdown = ({ eventDate }) => {
  const [ms, setMs] = useState(() => remaining(eventDate));
  useEffect(() => {
    setMs(remaining(eventDate));
    const t = setInterval(() => setMs(remaining(eventDate)), 1000);
    return () => clearInterval(t);
  }, [eventDate]);

  if (ms <= 0) {
    // Show "tonight" for the duration of the party, then hide.
    return ms > -6 * 3600000 ? (
      <span data-testid="countdown-live" className="mt-2 text-[10px] tracking-[0.3em] uppercase text-white/70 font-body">La serata è iniziata</span>
    ) : null;
  }

  let rest = ms;
  const parts = UNITS.map(([label, size]) => {
    const v = Math.floor(rest / size);
    rest -= v * size;
    return [label, v];
  });

  return (
    <div data-testid="countdown" className="mt-3 pt-3 border-t border-white/10 flex items-baseline gap-3 font-body">
      {parts.map(([label, v]) => (
        <span key={label} className="flex items-baseline gap-0.5" data-testid={`countdown-${label}`}>
          <span className="text-white text-base tabular-nums font-light">{String(v).padStart(2, "0")}</span>
          <span className="text-white/45 text-[10px] uppercase">{label}</span>
        </span>
      ))}
    </div>
  );
};
